import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=6ad37fc6&scoped=true&"
import script from "./EditQuestion.vue?vue&type=script&lang=ts&"
export * from "./EditQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./EditQuestion.vue?vue&type=style&index=0&id=6ad37fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad37fc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VOverlay,VProgressCircular,VSnackbar})
